import CategorySelector from '../category-selector';
import useStickerCategories from '../hooks/use-sticker-categories';

const StickerCategories = () => {
  const { stickerCategories } = useStickerCategories();

  return (
    <CategorySelector
      className='justify-start'
      categories={stickerCategories}
    />
  );
};

export default StickerCategories;
